import { FormNode, Theme } from './../core/models/form.model';
import { Component, ElementRef, OnInit, Optional, Pipe, PipeTransform, Self, ViewChild } from '@angular/core';
import { FormBuilder, NgControl, Validators, FormGroup } from '@angular/forms';
import { FieldConfig, mandatoryFields } from '../field.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, Meta } from '@angular/platform-browser';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormService } from '../_shared/services/form.service';
import { SubmissionService } from '../_shared/services/submission.service';
import { Submission } from '../core/models/submission.model';
import { Form } from '../core/models/form.model';
import Swal from 'sweetalert2';
import { DynamicForm2Component } from '../dynamic-form2/dynamic-form2.component';
import { ThemeService } from '../_shared/services/theme.service';
import { defaultLogo } from '../preview-form/default-logo';
import { SettingsService } from '../_shared/services/setting.service';

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustStyle(value);
  }
}


@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss']
})
export class RegistrationFormComponent implements OnInit {
  @ViewChild(DynamicForm2Component) form: DynamicForm2Component;
  private recaptchaElement: ElementRef;
  @ViewChild('recaptcha', {static: false }) set content(content: ElementRef) {
    if(content) { // initially setter gets called with undefined
        this.recaptchaElement = content;
        this.renderReCaptcha();
    }
  };
  captchaKey: string;
  formId: string;
  formConfig: FormGroup;
  formList: Array<FormNode> = [];
  answerList: Array<Array<any>> = [];
  formDetails: Form = {};
  generalSetting: any = {};
    
  regStaticFields: FieldConfig[] = mandatoryFields;
  submission: Submission = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
  };
  hideform: boolean=false;
  nodeTypeBlockedMessage: string = '';
  theme: Theme = {
    image: ""
  };

  constructor(
    private formBuilder: FormBuilder,
    private meta: Meta,
    private formService: FormService,
    private submissionService: SubmissionService,
    private settingService: SettingsService,
    private themeService: ThemeService,
    private loaderService: NgxUiLoaderService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    
  }

  get f() {
    return this.formConfig.controls;
  }

  getRegObjectConfig(i) {
    return { ...mandatoryFields[0] };
  }
  handleNextButton() {
    if (this.formConfig.dirty && this.formConfig.valid) {
      this.formList.push(this.formDetails.rootNode);
    } else {
      this.validateAllFormFields(this.formConfig);
    }
  }
  
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: false });
    });
  }

  ngOnInit() {
    this.settingService.getSettingById("GENERIC_SETTINGS").subscribe(setting => {
      this.generalSetting = JSON.parse(setting.value);
      var fields: any = {
        firstName: ['', [Validators.required, Validators.pattern("[ a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ'`'.@-]+")]],
        lastName: ['', [Validators.required,Validators.pattern("[a-zA-z][a-zA-Z ]+")]],
        emailAddress: ['', [Validators.required,Validators.pattern("^[A-z0-9._%+-]+@[A-z0-9.-]+\\.[A-z]{2,4}$")]],
      }
      if (!this.generalSetting.SkipPhoneInBasic) {
        fields.phoneNumber = ['', [Validators.pattern("^(\\+\\d{1,3}( )?)?((\\(\\d{1,3}\\))|\\d{1,3})[- .]?\\d{3,4}[- .]?\\d{4}$")]]
      }
      this.formConfig = this.formBuilder.group(fields);
    });
    this.route.queryParams.subscribe((params) => {
      if (params['formId']) {
        this.loadFormById(params['formId']);
      }
    });
    this.route.url.subscribe((params) => {
      let url = this.route.snapshot['_routerState'].url;
      if (url.split("/").length === 3) {
        this.loadFormById(url.substring(1));
      } else {
        this.router.navigateByUrl('/admin/forms');
      }
    });
    this.addRecaptchaScript();
  }

  loadFormById(id) {
    this.loaderService.start();
    this.formService.getPublicFormById(id).subscribe((response) => {
      if (response.id === "00000000-0000-0000-0000-000000000000") {
        this.router.navigateByUrl('/admin/forms');
      } else {
        if (response.preventSearchEngines) {
          this.meta.addTag({ name: 'robots', content: 'noindex,nofollow' });
          this.meta.addTag({ name: 'googlebot', content: 'noindex' });
        }
        this.formDetails = response;
        if(this.formDetails.theme.headerHtml) {
          this.formDetails.theme.headerHtml = this.formDetails.theme.headerHtml.replace("#LOGOURL#", (this.formDetails.logoUrl ? this.formDetails.logoUrl : defaultLogo));
        }
        this.loadThemeById(this.formDetails.themeId);
        this.parseOptions(this.formDetails.rootNode);
        this.formId = response.id;
        this.loaderService.stop()
      }
    }, (error) =>   this.loaderService.stop());
  }

  loadThemeById(id: string) {
    this.themeService.get()
    .subscribe((themes: any) => {
      this.theme = themes.filter(theme => theme.id == id)[0];
    });
  }

  getFields(form: any, i: any) {
    switch (form.nodeType) {
      case 2:
      case "2":
        return form.formFields = form.formFields.map((item: FieldConfig) => {
          item.containerClass = 'col-md-12 d-inline-flex mb-4';
          item.required = 'true';
          item.onChangeRequired = true;
          return item;
        });
        break;
      default:
        form.formFields = form.formFields.map((item: FieldConfig) => {
          return {
            ...item,
            containerClass: 'col-md-6 d-inline-flex mb-4',
          };
        });
        return [
          ...form.formFields.filter((item: any) => item.type !== 'hidden'),
          {
            type: 'button',
            label: 'Submit',
          },
        ];
    }
  }

  equals(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    } else {
      return Object.keys(obj1).every((key) => {
        return obj1[key] == obj2[key];
      });
    }
  }
  parseOptions(node: FormNode) {
    node.formFields = node.formFields.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
    node.formFields.forEach((formField) =>
      formField.options
        ? (formField.options = JSON.parse(formField.options))
        : []
    );
    node.children.forEach((child) => this.parseOptions(child));
  }

  submit(index: number, event: any) {
    this.formList = this.formList.slice(0, index + 1);
    if (this.formList[index].nodeType == "2") {
      const selectedChild = this.formList[index].children.find(
        (child: any) => {
          var entryConditions = JSON.parse(child.entryConditons ? child.entryConditons : '{}');
          if (entryConditions.length) {
            return entryConditions.some(entryCondition => this.equals(
              entryCondition,
              event.value
            ));
          } else {
            return this.equals(
              entryConditions,
              event.value
            )
          }
        }
      );
      this.formList.push(selectedChild);
    }

    this.answerList = this.answerList.slice(0, index);
    this.answerList.push(Object.keys(event.value).map((key) => {
      return {
        name: key,
        value: event.value[key],
      };
    }));

    if (this.formList[index].nodeType == "1") {
      if (!this.formDetails.showCaptcha || this.captchaKey) {
        Swal.fire({
          title: 'Are you sure?',
          text: 'You want to submit the form',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, submit it!',
          cancelButtonText: 'No, cancel it',
        }).then((result) => {
          if (result.value) {
            this.loaderService.start();
            this.submission.formId = this.formId;
            this.submission.formNodeId = this.formList[index].id;
            this.submission.submissionValues = this.answerList.reduce((prev, curr) => prev.concat(curr), []);
            this.submissionService
              .create(this.submission)
              .subscribe((response) => {
                this.loaderService.stop();
                Swal.fire(
                  'Submitted!',
                  'Thank you for your registration. Your form is being reviewed. We will email you confirmation when the enrollment is complete. That email will contain the URL where you will login and a link to set your password.',
                  'success'
                ).then(
                  () => {
                    window.location.href = response.tenantUrl;
                  },
                  () => {
                    window.location.href = response.tenantUrl;
                  }
                );
              }, error => {
                this.loaderService.stop();
              });
          }
        });
      } else {
        Swal.fire(
          'Invalid Captcha',
          'Please complete captcha verification',
          'error'
        )
      }
    } 
  }

  addRecaptchaScript() {
 
    window['grecaptchaCallback'] = () => {
      
    }
   
    (function(d, s, id, obj){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
   
  }

  renderReCaptcha() {
    
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey' : this.generalSetting.CaptchaKey,
      'expired-callback': (response) => {
        delete this.captchaKey;
      },
      'callback': (response) => {
        this.captchaKey = response;
        console.log(response);
      }
    });
  }
}
